import React from 'react'
import FavoriteIcon from '@material-ui/icons/FavoriteBorderSharp'
import Link from '../Link/Link'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { ReactSVG } from 'react-svg'
import { proxySvgUrl } from '@/utils/proxySvgUrl'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles(() => ({
  wishListLink: {
    '& svg': {
      height: '1.5rem !important',
      width: '1.5rem !important',
    },
  },
}))

export const WishListLink = ({
  className,
  url,
}: {
  className: string
  url: string
}) => {
  const classes = useStyles()
  const { trackEvent } = useMatomo()
  return (
    <Link href={'/wish-list'}>
      <a
        className={clsx(className, 'wish-list-go-to')}
        data-testid={'go_to_wish_list'}
        onClick={() =>
          trackEvent({
            category: 'user Wish List',
            action: `User go to his Wish List`,
          })
        }
      >
        {url ? (
          <ReactSVG className={classes.wishListLink} src={proxySvgUrl(url)} />
        ) : (
          <FavoriteIcon />
        )}
      </a>
    </Link>
  )
}
